/**
 * @module google-recaptcha/executeRecaptchaInvisible
 * @description
 * Обработчик для невидимой капчи.
 * 1. Находим блок капчи
 * 2. Если она уже верифицирована (executed), то получаем токен и возвращаем его.
 * 3. Если нужна верификация, то делаем execute и возвращаем null (отправку формы нужно отменить). После того как верификация будет пройдена произойдёт вызов callback-функции для отправки формы.
 *
 * Примеры использования можно увидеть в ui-feedback, ui-comment, ui-review.
 *
 * @param {DOMElement} form - форма
 * @param {function} callback - коллбек для повторной отправки формы
 * @param {string} formType - тип формы
 * @returns {string, null} - токен или null
 */
export default (form, callback, formType = '') => {
  if (!form || !callback || typeof callback !== 'function') {
    console.warn('В обработчик ReCaptcha Invisible не была передана форма или коллбек', form, callback);

    return;
  }

  if (!window.grecaptcha) {
    console.warn('Google ReCaptcha не загружена');

    return;
  }

  try {
    const recaptchaBlocks = Array.from(document.querySelectorAll('.g-recaptcha-response'));

    if (!recaptchaBlocks && !recaptchaBlocks.length) { return; }

    let currentRecaptchaElement = null;
    let recaptchaIndex = 0;

    // Этот коллбек сработает после верификации капчи
    window.recaptchaVerifyV3 = function(token) {
      if (currentRecaptchaElement) {
        const recaptchaInput = currentRecaptchaElement.querySelector(`[name="${formType}[g-recaptcha-response]"]`);

        // Добавляем поле с токеном в форму
        if (recaptchaInput) {
          recaptchaInput.value = token;
        } else if (formType) {
          currentRecaptchaElement.insertAdjacentHTML(
            'beforeend', `<input type="hidden" name="${formType}[g-recaptcha-response]" value="${token}">`
          );
        }
      }

      callback(form, token);
    };

    let token = null;

    // Находим идентификатор капчи для текущей формы и запускаем верификацию
    recaptchaBlocks.forEach((recaptchaWidget) => {
      const recaptchaElement = recaptchaWidget.closest('[data-size="invisible"]');

      if (!recaptchaElement || recaptchaElement.closest('form') !== form) {
        return;
      }

      // Достаём индекс капчи из идентификатора виджета
      const matches = recaptchaWidget.id.match(/\d+$/);
      recaptchaIndex = matches ? parseInt(matches[0]) : 0;

      currentRecaptchaElement = recaptchaElement;

      if (window.grecaptcha.getResponse(recaptchaIndex)) {
        token = window.grecaptcha.getResponse(recaptchaIndex);

        return;
      }

      window.grecaptcha.execute(recaptchaIndex);
    });

    return token;
  } catch (err) {
    console.warn(err);

    return false;
  }
};
